import * as loginAction from "./../../store/auth/login/actions";
import * as messageAction from "../../store/message/action";
import { Alert, Card, CardBody, Col, Container, Row } from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { Link, useHistory, withRouter } from "react-router-dom";
import React, { Component, useEffect, } from "react";
import { apiError, loginUser, socialLogin } from "../../store/actions";
import { facebook, google } from "../../config";
import { useDispatch, useSelector } from "react-redux";

import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { GoogleLogin } from "react-google-login";
import PropTypes from "prop-types";
import lightlogo from "../../assets/images/logo-light.svg";
import logo from "../../assets/images/logo.svg";
import profile from "../../assets/images/logo.png";
import backGround from "../../assets/images/Ptt.png";
import axios from "axios";


function Login() {
  const loginReducer = useSelector(state => state.Login);
  const dispatch = useDispatch();
  const history = useHistory();
  const handleValidSubmit = (event, values) => {
    // this.props.loginUser(values, this.props.history);
    dispatch(loginAction.login(values, history));
  };

  const countUserLogin = () => {

    var xhttp = new XMLHttpRequest();
    xhttp.open("POST","https://pmis.pipeline.pttplc.com/WebVisitorCounter/?Page=TSO-OpeRept",true);
    xhttp.send();

    // TSO Operation report
    // try {
    //   console.log("test")
    //   let res = await axios.post("https://tsoreport.pttplc.com/WebVisitorCounter/?Page=TSO-OpeRept");
      
    // } catch (error) {
    //   dispatch(messageAction.showMessage(error.message));
    // }
  }

  useEffect(function () {
    countUserLogin();
  }, []);

  return (
    <React.Fragment >
      {/* <div style={{ backgroundImage: `url(${backGround})` }}> */}
      {/* <div className="page-content" style={{ backgroundImage: `url(${backGround})` }}> */}

      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>

      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  {/* <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome !</h5>
                        <p>Sign in to continue to Skote.</p>
                      </div>
                    </Col>
                  </Row> */}
                  <Row>
                    <Col className="col-12 align-self-center">

                      <img src={profile} alt="" className="mx-auto d-block mt-2 mb-2" style={{ height: "60px" }} />
                      {/* src={logoPttColor}
                                                alt=""
                                                style={{ maxWidth: "190px" }}
                                                className="mx-auto d-block" //img-thumbnail */}
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="auth-logo">
                    {/* <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={lightlogo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                      <Link to="/" className="auth-logo-dark">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link> */}
                  </div>
                  <div className="p-2">
                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={handleValidSubmit}
                    >
                      {loginReducer.error && loginReducer.error ? (
                        <Alert color="danger">{loginReducer.error}</Alert>
                      ) : null}

                      <div className="mb-3">
                        <AvField
                          name="username"
                          label="Username"
                          value=""
                          // value="admin@themesbrand.com"
                          className="form-control"
                          placeholder="Enter username"
                          type="text"
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <AvField
                          name="password"
                          label="Password"
                          value=""
                          // value="123456"
                          type="password"
                          required
                          placeholder="Enter Password"
                        />
                      </div>

                      {/* <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div> */}

                      <div className="mt-4 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                        >
                          Log In
                        </button>
                      </div>

                      {/* <div className="mt-4 text-center">
                        <h5 className="font-size-14 mb-3">Sign in with</h5>

                        <ul className="list-inline">
                          <li className="list-inline-item">
                            <FacebookLogin
                              appId={facebook.APP_ID}
                              autoLoad={false}
                              callback={this.facebookResponse}
                              render={renderProps => (
                                <Link
                                  to={""}
                                  className="social-list-item bg-primary text-white border-primary"
                                >
                                  <i className="mdi mdi-facebook" />
                                </Link>
                              )}
                            />
                          </li>
                          <li className="list-inline-item">
                            <GoogleLogin
                              clientId={google.CLIENT_ID}
                              render={renderProps => (
                                <Link
                                  to={""}
                                  className="social-list-item bg-danger text-white border-danger"
                                >
                                  <i className="mdi mdi-google" />
                                </Link>
                              )}
                              onSuccess={this.googleResponse}
                              onFailure={() => {}}
                            />
                          </li>
                        </ul>
                      </div> */}

                      <div className="mt-4 text-center">
                        {/* <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" /> Forgot your
                          password?
                        </Link> */}
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              {/* <div className="mt-5 text-center">
                <p>
                  Don&apos;t have an account ?
                  <Link to="register" className="fw-medium text-primary">
                    Signup Now
                  </Link>
                </p>
                <p>
                  © {new Date().getFullYear()} Skote. Crafted with
                  <i className="mdi mdi-heart text-danger" /> by Themesbrand
                </p>
              </div> */}
            </Col>
          </Row>
        </Container>
      </div>

      {/* </div> */}
    </React.Fragment>
  );
}

export default Login;
